<template>
<div class="app-container">
  <div class="content">
    <div v-loading="loading">
      <div class="header-nav">
        <div class="back-btn" @click="popBack"><i class="el-icon-back"></i></div> <div class="list-title">DCP提交记录</div>
      </div>
      <template v-for="record in dcpRecordList">
        <div  class="list-item" @click="dcpDetail(record)" :key="record.bizDataId">
          <!-- <span>buid: {{bu.id}}</span> -->
          <div class="record-item">
              <div class="up">
                  <span>{{submitSatus(record)}}{{record.bizDataName}}</span>
                  <i class="el-icon-arrow-right"></i>
              </div>
              
              <div class="date">
                  <span>{{submitDate(record)}}</span>
              </div>
          </div>
        </div>
      </template>
      
    </div>
  </div>
</div>
</template>

<script>

import utils from '@/utils/domain';
import {dateFormat} from '@/utils/date';
import Axios from 'axios'
const axios = Axios.create({ })

export default {
components: {

},
data() {
  return {
    dcpRecordList: [],
    loading: false,
    projectId: "",
    dcpOperationDialogVisible: false
  };
},
computed: {

},
watch: {

},
methods: {
  popBack() {
    this.$router.back()
  },
  getDcpName(dcp){
    let processDetail = dcp.processDetail
    if(processDetail && processDetail.dataModelInfos && Array.isArray(processDetail.dataModelInfos)){
      return processDetail.dataModelInfos[0].modelName || processDetail.processName
    }
    return processDetail && processDetail.processName || ""
  },
    getDCPList() {
        this.loading = true
        let token = this.$store.state.loginToken
        console.log("login_token", token)
        axios.defaults.withCredentials = true
        // WARNING: 由于vetrust 只用一种dcp 此处写死bizDataType
        token && axios({
          url: utils.getDomain() + '/datapoint/list',
          method: 'POST',
          headers: {
            'x-api-token': token,
            'Content-Type':'application/json'
          },
          data: {
            datamodelUuid: this.$store.state.wechat.datamodelUuid,
            needPage: false,
            page: 0,
            size: 0,
            projectId: this.$store.state.wechat.projectId,
            bizDataType: "DATAPOINT",
            instanceUuid: this.$store.state.wechat.instanceUuid,
          }
        })
        .then(({ data }) => {

          console.log("resp_data", data)
          this.loading = false
          if(data.code === 'common.success') {
            this.dcpRecordList = data.data.list
          }
        })
        .catch(( error ) => {
          this.loading = false
          console.log("error_occur", error)
        })
    },
    getDataStatus(record){
      // 数据未进入终态, 数据不可编辑
      let softDataStatus = "enable"
      if(record.submitStatus &&  record.submitStatus !== "SUCCESS" && record.submitStatus !== "DRAFT_SUCCESS"){
        softDataStatus = "disable"
      }

      // 已有数据进入修改, 标识状态
      let editStatus = "init"
      if((record.status && record.status === "DRAFT") || 
         (record.submitStatus && record.submitStatus === "DRAFT_SUCCESS")) {
        editStatus = "draftedit"
      }
      const isSubmitSuccess = record.submitStatus && ( record.submitStatus === "SUCCESS" || record.submitStatus === "ONCHAIN" || record.submitStatus === "SUBMITED" ||record.submitStatus === "PROCESSING" )
      if((record.status && record.status === "SUBMIT") || 
         isSubmitSuccess) {
        editStatus = "submitedit"
      }

      // DCP类型
      let dcpType = "200005"
      return { softDataStatus, editStatus, dcpType }
    },
    dcpDetail(record){
      console.log("select-bu", record)
      // softDataStatus
      // editStatus: submitEdit/init/draftEdit
      // dcpType: custom: 200005
      // softDataStatus: disable & enable & none
      // dataInfo: record.dataInfo
      let { softDataStatus, editStatus, dcpType } = this.getDataStatus(record)
      // toast error
      if(record.dataInfo){
        this.$toast(record.dataInfo.message)
      }
      
      this.$router.push({path: "/v2", query: {
        wechat: true,
        bizDataId: record.bizDataId,
        dataUuid: record.dataUuid,
        statusData_softDataStatus: softDataStatus,
        statusData_editStatus: editStatus,
        statusData_dcpType: dcpType
      }})
    },
    submitSatus(record){
      // PROCESSING 
      // DRAFT_SUCCESS
      // SUBMITED
      // ONCHAIN
      // SUCCESS
      let statusMap = {
        PROCESSING: "【提交中】",
        DRAFT_SUCCESS: "【草稿】",
        SUBMITED: "【已提交】",
        ONCHAIN: "【上链中】",
        SUCCESS: "【上链成功】"
      }
      let statusKey = record.submitStatus || record.status || record.nOnChainStatus  || record.blockChainStatus||  "DRAFT_SUCCESS" 

      return statusMap[statusKey]
    },
    submitDate(record){
        // dateTools
        let date = record.updateTime || record.submitTime || record.operateTime
        if(date === undefined){
          return ""
        }
        return dateFormat(date, "yyyy-MM-dd hh:mm:ss")
    }
},
created() {

},
mounted() {

  this.getDCPList()
},
}
</script>

<style lang="scss" scoped>
  .app-container {
    width: 100vw;
    max-width: 750px;
    font-size: 16px;
    margin: 0 auto;
    display: flex;
    align-items: flex-start;
    justify-content: center;
    flex-direction: column;
    .content {
      flex: 1;

      .header-nav {
        display: flex;
        i {
          width: 20px;
          height: 20px;
        }
        .back-btn {
          padding: 10px;
          height: 20px;
          font-size: 16px;
        }
      }

      .list-title {
        padding: 10px;
        height: 20px;
        color: #999;
        font-size: 16px;
        // position: sticky;
      }

      .list-item {
        height: 44px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 10px;
        margin: 10px;
        margin-top: 15px;
        width: calc(100vw - 40px);
        max-width: 750px;
        box-shadow: 0 0 0 2px #ffffff, 0 0 6px 3px #cccccc;
        .record-item {
          flex: 1;
          display: flex;
          align-items: center;
          // justify-content: space-between;
          flex-direction: column;
          .up {
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-bottom: 5px;
          }
          .date {
            padding-top: 5px;
            border-top: 1px solid #ccc;
            width: 100%;
            display: flex;
            // align-items: flex-start;
            justify-content: flex-start;
            font-size: 14px;
          }
        }
      }
    }
  }
</style>